(function () {
    'use strict';

    angular
        .module('Lavpop-store.services')
        .service('CategoryService', CategoryService)

    /** @ngInject */
    function CategoryService(HttpService) {
        const CategoryService = {
            getAll: getAll
        };

        return CategoryService;

        function getAll() {
            return HttpService.get('/categories/resumed');
        }
    }
}());